/**
 * Icon mark only: two amber gradient lines (no wordmark). For favicon, loading, badges, pattern.
 * Sizes: ico-xs | ico-sm | ico-md | ico-lg | ico-xl. Variants: solid | on-amber.
 */
import React from 'react';
import './brand.css';

const SIZES = ['ico-xs', 'ico-sm', 'ico-md', 'ico-lg', 'ico-xl'];

export default function SovrynnIcon({ size = 'ico-md', variant, className = '' }) {
  const sizeClass = SIZES.includes(size) ? size : 'ico-md';
  const variantClass = variant === 'on-amber' ? 'on-amber' : variant === 'solid' ? 'solid' : '';
  const classes = ['sv-icon', sizeClass, variantClass, className].filter(Boolean).join(' ');
  return (
    <div className={classes} aria-hidden>
      <div className="sv-icon__i1" />
      <div className="sv-icon__i2" />
    </div>
  );
}
